import { useState } from 'react';
import PruebasApisHome from './PruebasApisHome.tsx';
import S4HanaApis from './S4HanaApis.tsx';
import DocusignApis from './DocusignApis.tsx';
import AribaApiTester from './AribaApiTester.tsx';
import { ApiConnectionCredentials, EMPTY_API_CREDENTIALS } from './apiCredentials.types.ts';

// Versión embebida del hub "Pruebas APIs" para usarse dentro de un
// proyecto (ver HomeCA.tsx, sección "Herramientas"). A diferencia de la
// tarjeta global del Home, aquí clienteId viene del proyecto y las
// credenciales no se piden a mano: se cargan desde la Configuración ya
// guardada del cliente (ver CredencialesApiPanel.tsx).
type SubPage = 'pruebas-apis' | 's4-apis' | 'docusign-apis' | 'ariba-api-test';

interface PruebasApisProyectoProps {
  clienteId?: string;
  clienteNombre?: string;
  projectId?: string;
}

export default function PruebasApisProyecto({ clienteId, clienteNombre, projectId }: PruebasApisProyectoProps) {
  const [subPage, setSubPage] = useState<SubPage>('pruebas-apis');
  const [credentials, setCredentials] = useState<ApiConnectionCredentials>(EMPTY_API_CREDENTIALS);

  const goTo = (target: string) => {
    if (target === 's4-apis' || target === 'docusign-apis' || target === 'ariba-api-test' || target === 'pruebas-apis') {
      setSubPage(target);
    }
  };

  if (subPage === 's4-apis') {
    return <S4HanaApis setPage={goTo} embedded credentials={credentials} />;
  }
  if (subPage === 'docusign-apis') {
    return <DocusignApis setPage={goTo} embedded credentials={credentials} />;
  }
  if (subPage === 'ariba-api-test') {
    return <AribaApiTester setPage={goTo} embedded clienteId={clienteId} projectId={projectId} credentials={credentials} />;
  }
  return (
    <PruebasApisHome
      setPage={goTo}
      embedded
      clienteId={clienteId}
      clienteNombre={clienteNombre}
      credentials={credentials}
      onCredentialsChange={setCredentials}
    />
  );
}
